import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * Styled NATIVE select — on iOS/Android it opens the platform picker wheel,
 * which is exactly right for short option lists. Callers provide the
 * accessible name (aria-label or a wired <label>).
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(
        'h-9 rounded-md border border-line-2 bg-card px-2.5 font-sans text-body text-t1',
        'pointer-coarse:min-h-[44px]',
        'outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas',
        className,
      )}
      {...rest}
    />
  );
});
